/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CloudAssetIntegration } from '../models';
// @ts-ignore
import type { CloudAssetIntegrationSyncReport } from '../models';
// @ts-ignore
import type { CreateCloudAssetIntegrationInput } from '../models';
// @ts-ignore
import type { GetCloudAssetIntegrationCleanupCommandResponse } from '../models';
// @ts-ignore
import type { GetCloudAssetIntegrationOnboardingCommandResponse } from '../models';
// @ts-ignore
import type { GetCloudAssetIntegrationOnboardingConfigResponse } from '../models';
// @ts-ignore
import type { ListCloudAssetIntegrationsResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { UpdateCloudAssetIntegrationInput } from '../models';
/**
 * CloudAssetIntegrationsAPIApi - axios parameter creator
 * @export
 */
export const CloudAssetIntegrationsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new cloud asset integration.
         * @summary Create a new cloud asset integration.
         * @param {string} organizationId The ID of the organization.
         * @param {CreateCloudAssetIntegrationInput} createCloudAssetIntegrationInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPICreateCloudAssetIntegration: async (organizationId: string, createCloudAssetIntegrationInput: CreateCloudAssetIntegrationInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cloudAssetIntegrationsAPICreateCloudAssetIntegration', 'organizationId', organizationId)
            // verify required parameter 'createCloudAssetIntegrationInput' is not null or undefined
            assertParamExists('cloudAssetIntegrationsAPICreateCloudAssetIntegration', 'createCloudAssetIntegrationInput', createCloudAssetIntegrationInput)
            const localVarPath = `/inventory/v1beta/organizations/{organizationId}/cloud-asset-integrations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCloudAssetIntegrationInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a cloud asset integration.
         * @summary Delete a cloud asset integration.
         * @param {string} organizationId The ID of the organization.
         * @param {string} id The ID of the cloud asset integration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIDeleteCloudAssetIntegration: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cloudAssetIntegrationsAPIDeleteCloudAssetIntegration', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cloudAssetIntegrationsAPIDeleteCloudAssetIntegration', 'id', id)
            const localVarPath = `/inventory/v1beta/organizations/{organizationId}/cloud-asset-integrations/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a cloud asset integration.
         * @summary Get a cloud asset integration.
         * @param {string} organizationId The ID of the organization.
         * @param {string} id The ID of the cloud asset integration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIGetCloudAssetIntegration: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cloudAssetIntegrationsAPIGetCloudAssetIntegration', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cloudAssetIntegrationsAPIGetCloudAssetIntegration', 'id', id)
            const localVarPath = `/inventory/v1beta/organizations/{organizationId}/cloud-asset-integrations/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the cleanup command for a cloud provider. This will clean up all resources for the specified cloud provider.
         * @summary Get the cleanup command for a cloud provider.
         * @param {string} organizationId The ID of the organization.
         * @param {CloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommandProviderEnum} [provider] The cloud provider to clean up resources for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommand: async (organizationId: string, provider?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommandProviderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommand', 'organizationId', organizationId)
            const localVarPath = `/inventory/v1beta/organizations/{organizationId}/cloud-asset-integrations:getCleanupCommand`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the cleanup script for a cloud provider. This will clean up all resources for the specified cloud provider.
         * @summary Get the cleanup script for a cloud provider.
         * @param {string} organizationId The ID of the organization.
         * @param {CloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScriptProviderEnum} [provider] The cloud provider to clean up resources for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScript: async (organizationId: string, provider?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScriptProviderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScript', 'organizationId', organizationId)
            const localVarPath = `/inventory/v1beta/organizations/{organizationId}/cloud-asset-integrations:getCleanupScript`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the onboarding command for a cloud asset integration.
         * @summary Get the onboarding command for a cloud asset integration.
         * @param {string} organizationId The ID of the organization.
         * @param {CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandProviderEnum} [provider] The cloud provider.
         * @param {Array<string>} [gcpConfigOrganizationIds] Optional GCP organization IDs. If provided, the onboarding script will attempt to create organization-level IAM bindings only for the specified organizations.
         * @param {string} [gcpConfigProjectId] Optional GCP project ID. If provided, the onboarding script will create a service account in this project.
         * @param {Array<string>} [gcpConfigProjectIds] Optional GCP project IDs. If provided, the onboarding script will create IAM bindings only in these projects.
         * @param {string} [azureConfigTenantId] Optional Azure tenant ID. If provided, the onboarding script will setup the integration for the specified tenant. Otherwise, it will programatically obtain the tenant ID from the Azure CLI.
         * @param {Array<string>} [azureConfigSubscriptionIds] Optional list of Azure subscription IDs to restrict the integration to. If provided, the onboarding script will only setup access for these subscriptions. Otherwise, it will setup access for all available subscriptions.
         * @param {string} [awsConfigCurConfigS3BucketName] S3 bucket name containing a CUR export. If provided, the onboarding script will create an IAM policy to allow access to the specified bucket.
         * @param {string} [awsConfigCurConfigS3Region] Region of the S3 bucket containing the CUR export. Must be provided if s3_bucket_name is provided.
         * @param {string} [awsConfigCurConfigS3AccountId] Optional AWS account ID containing the CUR export for organization-scoped integrations. If not provided, defaults to management account ID.
         * @param {boolean} [awsConfigForceAccountScope] If true, the onboarding script will force account-scoped integration even if it\&#39;s ran by a management account.
         * @param {Array<string>} [awsConfigAccountIds] Optional list of AWS account IDs to restrict the integration to. For organization-scoped integrations, the onboarding script will only deploy roles to these accounts. The integration will only sync resources from these accounts.
         * @param {CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandScopeEnum} [scope] The scope of the cloud asset integration. If not provided, defaults to ALL.
         * @param {CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandIntegrationSettingsCommitmentsDefaultStatusEnum} [integrationSettingsCommitmentsDefaultStatus] The default status of the commitment to be assigned to newly imported ones.
         * @param {boolean} [integrationSettingsCommitmentsAssignAutomatically] If true, the commitment will be automatically assigned to clusters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand: async (organizationId: string, provider?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandProviderEnum, gcpConfigOrganizationIds?: Array<string>, gcpConfigProjectId?: string, gcpConfigProjectIds?: Array<string>, azureConfigTenantId?: string, azureConfigSubscriptionIds?: Array<string>, awsConfigCurConfigS3BucketName?: string, awsConfigCurConfigS3Region?: string, awsConfigCurConfigS3AccountId?: string, awsConfigForceAccountScope?: boolean, awsConfigAccountIds?: Array<string>, scope?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandScopeEnum, integrationSettingsCommitmentsDefaultStatus?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandIntegrationSettingsCommitmentsDefaultStatusEnum, integrationSettingsCommitmentsAssignAutomatically?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand', 'organizationId', organizationId)
            const localVarPath = `/inventory/v1beta/organizations/{organizationId}/cloud-asset-integrations:getOnboardingCommand`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }

            if (gcpConfigOrganizationIds) {
                localVarQueryParameter['gcpConfig.organizationIds'] = gcpConfigOrganizationIds;
            }

            if (gcpConfigProjectId !== undefined) {
                localVarQueryParameter['gcpConfig.projectId'] = gcpConfigProjectId;
            }

            if (gcpConfigProjectIds) {
                localVarQueryParameter['gcpConfig.projectIds'] = gcpConfigProjectIds;
            }

            if (azureConfigTenantId !== undefined) {
                localVarQueryParameter['azureConfig.tenantId'] = azureConfigTenantId;
            }

            if (azureConfigSubscriptionIds) {
                localVarQueryParameter['azureConfig.subscriptionIds'] = azureConfigSubscriptionIds;
            }

            if (awsConfigCurConfigS3BucketName !== undefined) {
                localVarQueryParameter['awsConfig.curConfig.s3BucketName'] = awsConfigCurConfigS3BucketName;
            }

            if (awsConfigCurConfigS3Region !== undefined) {
                localVarQueryParameter['awsConfig.curConfig.s3Region'] = awsConfigCurConfigS3Region;
            }

            if (awsConfigCurConfigS3AccountId !== undefined) {
                localVarQueryParameter['awsConfig.curConfig.s3AccountId'] = awsConfigCurConfigS3AccountId;
            }

            if (awsConfigForceAccountScope !== undefined) {
                localVarQueryParameter['awsConfig.forceAccountScope'] = awsConfigForceAccountScope;
            }

            if (awsConfigAccountIds) {
                localVarQueryParameter['awsConfig.accountIds'] = awsConfigAccountIds;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (integrationSettingsCommitmentsDefaultStatus !== undefined) {
                localVarQueryParameter['integrationSettings.commitments.defaultStatus'] = integrationSettingsCommitmentsDefaultStatus;
            }

            if (integrationSettingsCommitmentsAssignAutomatically !== undefined) {
                localVarQueryParameter['integrationSettings.commitments.assignAutomatically'] = integrationSettingsCommitmentsAssignAutomatically;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the onboarding config for a cloud asset integration. Returns structured configuration  including provider-specific permissions and identifiers needed for programmatic onboarding (e.g. Terraform).
         * @summary Get the onboarding config for a cloud asset integration.
         * @param {string} organizationId The ID of the organization.
         * @param {CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigProviderEnum} [provider] The cloud provider.
         * @param {Array<string>} [gcpConfigOrganizationIds] Optional GCP organization IDs. If provided, the onboarding script will attempt to create organization-level IAM bindings only for the specified organizations.
         * @param {string} [gcpConfigProjectId] Optional GCP project ID. If provided, the onboarding script will create a service account in this project.
         * @param {Array<string>} [gcpConfigProjectIds] Optional GCP project IDs. If provided, the onboarding script will create IAM bindings only in these projects.
         * @param {string} [azureConfigTenantId] Optional Azure tenant ID. If provided, the onboarding script will setup the integration for the specified tenant. Otherwise, it will programatically obtain the tenant ID from the Azure CLI.
         * @param {Array<string>} [azureConfigSubscriptionIds] Optional list of Azure subscription IDs to restrict the integration to. If provided, the onboarding script will only setup access for these subscriptions. Otherwise, it will setup access for all available subscriptions.
         * @param {string} [awsConfigCurConfigS3BucketName] S3 bucket name containing a CUR export. If provided, the onboarding script will create an IAM policy to allow access to the specified bucket.
         * @param {string} [awsConfigCurConfigS3Region] Region of the S3 bucket containing the CUR export. Must be provided if s3_bucket_name is provided.
         * @param {string} [awsConfigCurConfigS3AccountId] Optional AWS account ID containing the CUR export for organization-scoped integrations. If not provided, defaults to management account ID.
         * @param {boolean} [awsConfigForceAccountScope] If true, the onboarding script will force account-scoped integration even if it\&#39;s ran by a management account.
         * @param {Array<string>} [awsConfigAccountIds] Optional list of AWS account IDs to restrict the integration to. For organization-scoped integrations, the onboarding script will only deploy roles to these accounts. The integration will only sync resources from these accounts.
         * @param {CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigScopeEnum} [scope] The scope of the cloud asset integration. If not provided, defaults to ALL.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig: async (organizationId: string, provider?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigProviderEnum, gcpConfigOrganizationIds?: Array<string>, gcpConfigProjectId?: string, gcpConfigProjectIds?: Array<string>, azureConfigTenantId?: string, azureConfigSubscriptionIds?: Array<string>, awsConfigCurConfigS3BucketName?: string, awsConfigCurConfigS3Region?: string, awsConfigCurConfigS3AccountId?: string, awsConfigForceAccountScope?: boolean, awsConfigAccountIds?: Array<string>, scope?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigScopeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig', 'organizationId', organizationId)
            const localVarPath = `/inventory/v1beta/organizations/{organizationId}/cloud-asset-integrations:getOnboardingConfig`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }

            if (gcpConfigOrganizationIds) {
                localVarQueryParameter['gcpConfig.organizationIds'] = gcpConfigOrganizationIds;
            }

            if (gcpConfigProjectId !== undefined) {
                localVarQueryParameter['gcpConfig.projectId'] = gcpConfigProjectId;
            }

            if (gcpConfigProjectIds) {
                localVarQueryParameter['gcpConfig.projectIds'] = gcpConfigProjectIds;
            }

            if (azureConfigTenantId !== undefined) {
                localVarQueryParameter['azureConfig.tenantId'] = azureConfigTenantId;
            }

            if (azureConfigSubscriptionIds) {
                localVarQueryParameter['azureConfig.subscriptionIds'] = azureConfigSubscriptionIds;
            }

            if (awsConfigCurConfigS3BucketName !== undefined) {
                localVarQueryParameter['awsConfig.curConfig.s3BucketName'] = awsConfigCurConfigS3BucketName;
            }

            if (awsConfigCurConfigS3Region !== undefined) {
                localVarQueryParameter['awsConfig.curConfig.s3Region'] = awsConfigCurConfigS3Region;
            }

            if (awsConfigCurConfigS3AccountId !== undefined) {
                localVarQueryParameter['awsConfig.curConfig.s3AccountId'] = awsConfigCurConfigS3AccountId;
            }

            if (awsConfigForceAccountScope !== undefined) {
                localVarQueryParameter['awsConfig.forceAccountScope'] = awsConfigForceAccountScope;
            }

            if (awsConfigAccountIds) {
                localVarQueryParameter['awsConfig.accountIds'] = awsConfigAccountIds;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the onboarding script for a cloud asset integration.
         * @summary Get the onboarding script for a cloud asset integration.
         * @param {string} organizationId The ID of the organization.
         * @param {CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScriptProviderEnum} [provider] The cloud provider.
         * @param {string} [trackingSessionId] Tracking session ID that should be passed if client wants to  associate GetCloudAssetIntegrationOnboardingScriptRequest with tracking session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScript: async (organizationId: string, provider?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScriptProviderEnum, trackingSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScript', 'organizationId', organizationId)
            const localVarPath = `/inventory/v1beta/organizations/{organizationId}/cloud-asset-integrations:getOnboardingScript`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }

            if (trackingSessionId !== undefined) {
                localVarQueryParameter['trackingSessionId'] = trackingSessionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the sync report for a cloud asset integration.  The report is a singleton sub-resource of the integration and contains the  most recent sync run for each (provider_namespace_id, asset_type) pair,  exposing the same rows that feed the derived CloudAssetIntegration.state.
         * @summary Get the sync report for a cloud asset integration.
         * @param {string} organizationId The ID of the organization.
         * @param {string} cloudAssetIntegrationId The ID of the cloud asset integration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReport: async (organizationId: string, cloudAssetIntegrationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReport', 'organizationId', organizationId)
            // verify required parameter 'cloudAssetIntegrationId' is not null or undefined
            assertParamExists('cloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReport', 'cloudAssetIntegrationId', cloudAssetIntegrationId)
            const localVarPath = `/inventory/v1beta/organizations/{organizationId}/cloud-asset-integrations/{cloudAssetIntegrationId}/sync-report`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cloudAssetIntegrationId"}}`, encodeURIComponent(String(cloudAssetIntegrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists cloud asset integrations.
         * @summary Lists cloud asset integrations.
         * @param {string} organizationId The ID of the organization.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIListCloudAssetIntegrations: async (organizationId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cloudAssetIntegrationsAPIListCloudAssetIntegrations', 'organizationId', organizationId)
            const localVarPath = `/inventory/v1beta/organizations/{organizationId}/cloud-asset-integrations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing cloud asset integration.
         * @summary Update an existing cloud asset integration.
         * @param {string} organizationId The ID of the organization.
         * @param {string} id The ID of the cloud asset integration.
         * @param {UpdateCloudAssetIntegrationInput} updateCloudAssetIntegrationInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIUpdateCloudAssetIntegration: async (organizationId: string, id: string, updateCloudAssetIntegrationInput: UpdateCloudAssetIntegrationInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cloudAssetIntegrationsAPIUpdateCloudAssetIntegration', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cloudAssetIntegrationsAPIUpdateCloudAssetIntegration', 'id', id)
            // verify required parameter 'updateCloudAssetIntegrationInput' is not null or undefined
            assertParamExists('cloudAssetIntegrationsAPIUpdateCloudAssetIntegration', 'updateCloudAssetIntegrationInput', updateCloudAssetIntegrationInput)
            const localVarPath = `/inventory/v1beta/organizations/{organizationId}/cloud-asset-integrations/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCloudAssetIntegrationInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CloudAssetIntegrationsAPIApi - functional programming interface
 * @export
 */
export const CloudAssetIntegrationsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CloudAssetIntegrationsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new cloud asset integration.
         * @summary Create a new cloud asset integration.
         * @param {string} organizationId The ID of the organization.
         * @param {CreateCloudAssetIntegrationInput} createCloudAssetIntegrationInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloudAssetIntegrationsAPICreateCloudAssetIntegration(organizationId: string, createCloudAssetIntegrationInput: CreateCloudAssetIntegrationInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CloudAssetIntegration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloudAssetIntegrationsAPICreateCloudAssetIntegration(organizationId, createCloudAssetIntegrationInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CloudAssetIntegrationsAPIApi.cloudAssetIntegrationsAPICreateCloudAssetIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a cloud asset integration.
         * @summary Delete a cloud asset integration.
         * @param {string} organizationId The ID of the organization.
         * @param {string} id The ID of the cloud asset integration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloudAssetIntegrationsAPIDeleteCloudAssetIntegration(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloudAssetIntegrationsAPIDeleteCloudAssetIntegration(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CloudAssetIntegrationsAPIApi.cloudAssetIntegrationsAPIDeleteCloudAssetIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a cloud asset integration.
         * @summary Get a cloud asset integration.
         * @param {string} organizationId The ID of the organization.
         * @param {string} id The ID of the cloud asset integration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloudAssetIntegrationsAPIGetCloudAssetIntegration(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CloudAssetIntegration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloudAssetIntegrationsAPIGetCloudAssetIntegration(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CloudAssetIntegrationsAPIApi.cloudAssetIntegrationsAPIGetCloudAssetIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the cleanup command for a cloud provider. This will clean up all resources for the specified cloud provider.
         * @summary Get the cleanup command for a cloud provider.
         * @param {string} organizationId The ID of the organization.
         * @param {CloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommandProviderEnum} [provider] The cloud provider to clean up resources for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommand(organizationId: string, provider?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommandProviderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCloudAssetIntegrationCleanupCommandResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommand(organizationId, provider, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CloudAssetIntegrationsAPIApi.cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the cleanup script for a cloud provider. This will clean up all resources for the specified cloud provider.
         * @summary Get the cleanup script for a cloud provider.
         * @param {string} organizationId The ID of the organization.
         * @param {CloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScriptProviderEnum} [provider] The cloud provider to clean up resources for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScript(organizationId: string, provider?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScriptProviderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScript(organizationId, provider, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CloudAssetIntegrationsAPIApi.cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the onboarding command for a cloud asset integration.
         * @summary Get the onboarding command for a cloud asset integration.
         * @param {string} organizationId The ID of the organization.
         * @param {CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandProviderEnum} [provider] The cloud provider.
         * @param {Array<string>} [gcpConfigOrganizationIds] Optional GCP organization IDs. If provided, the onboarding script will attempt to create organization-level IAM bindings only for the specified organizations.
         * @param {string} [gcpConfigProjectId] Optional GCP project ID. If provided, the onboarding script will create a service account in this project.
         * @param {Array<string>} [gcpConfigProjectIds] Optional GCP project IDs. If provided, the onboarding script will create IAM bindings only in these projects.
         * @param {string} [azureConfigTenantId] Optional Azure tenant ID. If provided, the onboarding script will setup the integration for the specified tenant. Otherwise, it will programatically obtain the tenant ID from the Azure CLI.
         * @param {Array<string>} [azureConfigSubscriptionIds] Optional list of Azure subscription IDs to restrict the integration to. If provided, the onboarding script will only setup access for these subscriptions. Otherwise, it will setup access for all available subscriptions.
         * @param {string} [awsConfigCurConfigS3BucketName] S3 bucket name containing a CUR export. If provided, the onboarding script will create an IAM policy to allow access to the specified bucket.
         * @param {string} [awsConfigCurConfigS3Region] Region of the S3 bucket containing the CUR export. Must be provided if s3_bucket_name is provided.
         * @param {string} [awsConfigCurConfigS3AccountId] Optional AWS account ID containing the CUR export for organization-scoped integrations. If not provided, defaults to management account ID.
         * @param {boolean} [awsConfigForceAccountScope] If true, the onboarding script will force account-scoped integration even if it\&#39;s ran by a management account.
         * @param {Array<string>} [awsConfigAccountIds] Optional list of AWS account IDs to restrict the integration to. For organization-scoped integrations, the onboarding script will only deploy roles to these accounts. The integration will only sync resources from these accounts.
         * @param {CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandScopeEnum} [scope] The scope of the cloud asset integration. If not provided, defaults to ALL.
         * @param {CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandIntegrationSettingsCommitmentsDefaultStatusEnum} [integrationSettingsCommitmentsDefaultStatus] The default status of the commitment to be assigned to newly imported ones.
         * @param {boolean} [integrationSettingsCommitmentsAssignAutomatically] If true, the commitment will be automatically assigned to clusters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand(organizationId: string, provider?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandProviderEnum, gcpConfigOrganizationIds?: Array<string>, gcpConfigProjectId?: string, gcpConfigProjectIds?: Array<string>, azureConfigTenantId?: string, azureConfigSubscriptionIds?: Array<string>, awsConfigCurConfigS3BucketName?: string, awsConfigCurConfigS3Region?: string, awsConfigCurConfigS3AccountId?: string, awsConfigForceAccountScope?: boolean, awsConfigAccountIds?: Array<string>, scope?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandScopeEnum, integrationSettingsCommitmentsDefaultStatus?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandIntegrationSettingsCommitmentsDefaultStatusEnum, integrationSettingsCommitmentsAssignAutomatically?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCloudAssetIntegrationOnboardingCommandResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand(organizationId, provider, gcpConfigOrganizationIds, gcpConfigProjectId, gcpConfigProjectIds, azureConfigTenantId, azureConfigSubscriptionIds, awsConfigCurConfigS3BucketName, awsConfigCurConfigS3Region, awsConfigCurConfigS3AccountId, awsConfigForceAccountScope, awsConfigAccountIds, scope, integrationSettingsCommitmentsDefaultStatus, integrationSettingsCommitmentsAssignAutomatically, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CloudAssetIntegrationsAPIApi.cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the onboarding config for a cloud asset integration. Returns structured configuration  including provider-specific permissions and identifiers needed for programmatic onboarding (e.g. Terraform).
         * @summary Get the onboarding config for a cloud asset integration.
         * @param {string} organizationId The ID of the organization.
         * @param {CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigProviderEnum} [provider] The cloud provider.
         * @param {Array<string>} [gcpConfigOrganizationIds] Optional GCP organization IDs. If provided, the onboarding script will attempt to create organization-level IAM bindings only for the specified organizations.
         * @param {string} [gcpConfigProjectId] Optional GCP project ID. If provided, the onboarding script will create a service account in this project.
         * @param {Array<string>} [gcpConfigProjectIds] Optional GCP project IDs. If provided, the onboarding script will create IAM bindings only in these projects.
         * @param {string} [azureConfigTenantId] Optional Azure tenant ID. If provided, the onboarding script will setup the integration for the specified tenant. Otherwise, it will programatically obtain the tenant ID from the Azure CLI.
         * @param {Array<string>} [azureConfigSubscriptionIds] Optional list of Azure subscription IDs to restrict the integration to. If provided, the onboarding script will only setup access for these subscriptions. Otherwise, it will setup access for all available subscriptions.
         * @param {string} [awsConfigCurConfigS3BucketName] S3 bucket name containing a CUR export. If provided, the onboarding script will create an IAM policy to allow access to the specified bucket.
         * @param {string} [awsConfigCurConfigS3Region] Region of the S3 bucket containing the CUR export. Must be provided if s3_bucket_name is provided.
         * @param {string} [awsConfigCurConfigS3AccountId] Optional AWS account ID containing the CUR export for organization-scoped integrations. If not provided, defaults to management account ID.
         * @param {boolean} [awsConfigForceAccountScope] If true, the onboarding script will force account-scoped integration even if it\&#39;s ran by a management account.
         * @param {Array<string>} [awsConfigAccountIds] Optional list of AWS account IDs to restrict the integration to. For organization-scoped integrations, the onboarding script will only deploy roles to these accounts. The integration will only sync resources from these accounts.
         * @param {CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigScopeEnum} [scope] The scope of the cloud asset integration. If not provided, defaults to ALL.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig(organizationId: string, provider?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigProviderEnum, gcpConfigOrganizationIds?: Array<string>, gcpConfigProjectId?: string, gcpConfigProjectIds?: Array<string>, azureConfigTenantId?: string, azureConfigSubscriptionIds?: Array<string>, awsConfigCurConfigS3BucketName?: string, awsConfigCurConfigS3Region?: string, awsConfigCurConfigS3AccountId?: string, awsConfigForceAccountScope?: boolean, awsConfigAccountIds?: Array<string>, scope?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigScopeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCloudAssetIntegrationOnboardingConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig(organizationId, provider, gcpConfigOrganizationIds, gcpConfigProjectId, gcpConfigProjectIds, azureConfigTenantId, azureConfigSubscriptionIds, awsConfigCurConfigS3BucketName, awsConfigCurConfigS3Region, awsConfigCurConfigS3AccountId, awsConfigForceAccountScope, awsConfigAccountIds, scope, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CloudAssetIntegrationsAPIApi.cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the onboarding script for a cloud asset integration.
         * @summary Get the onboarding script for a cloud asset integration.
         * @param {string} organizationId The ID of the organization.
         * @param {CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScriptProviderEnum} [provider] The cloud provider.
         * @param {string} [trackingSessionId] Tracking session ID that should be passed if client wants to  associate GetCloudAssetIntegrationOnboardingScriptRequest with tracking session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScript(organizationId: string, provider?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScriptProviderEnum, trackingSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScript(organizationId, provider, trackingSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CloudAssetIntegrationsAPIApi.cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the sync report for a cloud asset integration.  The report is a singleton sub-resource of the integration and contains the  most recent sync run for each (provider_namespace_id, asset_type) pair,  exposing the same rows that feed the derived CloudAssetIntegration.state.
         * @summary Get the sync report for a cloud asset integration.
         * @param {string} organizationId The ID of the organization.
         * @param {string} cloudAssetIntegrationId The ID of the cloud asset integration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReport(organizationId: string, cloudAssetIntegrationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CloudAssetIntegrationSyncReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReport(organizationId, cloudAssetIntegrationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CloudAssetIntegrationsAPIApi.cloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists cloud asset integrations.
         * @summary Lists cloud asset integrations.
         * @param {string} organizationId The ID of the organization.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloudAssetIntegrationsAPIListCloudAssetIntegrations(organizationId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCloudAssetIntegrationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloudAssetIntegrationsAPIListCloudAssetIntegrations(organizationId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CloudAssetIntegrationsAPIApi.cloudAssetIntegrationsAPIListCloudAssetIntegrations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an existing cloud asset integration.
         * @summary Update an existing cloud asset integration.
         * @param {string} organizationId The ID of the organization.
         * @param {string} id The ID of the cloud asset integration.
         * @param {UpdateCloudAssetIntegrationInput} updateCloudAssetIntegrationInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloudAssetIntegrationsAPIUpdateCloudAssetIntegration(organizationId: string, id: string, updateCloudAssetIntegrationInput: UpdateCloudAssetIntegrationInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CloudAssetIntegration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloudAssetIntegrationsAPIUpdateCloudAssetIntegration(organizationId, id, updateCloudAssetIntegrationInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CloudAssetIntegrationsAPIApi.cloudAssetIntegrationsAPIUpdateCloudAssetIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CloudAssetIntegrationsAPIApi - factory interface
 * @export
 */
export const CloudAssetIntegrationsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CloudAssetIntegrationsAPIApiFp(configuration)
    return {
        /**
         * Creates a new cloud asset integration.
         * @summary Create a new cloud asset integration.
         * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPICreateCloudAssetIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPICreateCloudAssetIntegration(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPICreateCloudAssetIntegrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CloudAssetIntegration> {
            return localVarFp.cloudAssetIntegrationsAPICreateCloudAssetIntegration(requestParameters.organizationId, requestParameters.createCloudAssetIntegrationInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a cloud asset integration.
         * @summary Delete a cloud asset integration.
         * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIDeleteCloudAssetIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIDeleteCloudAssetIntegration(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIDeleteCloudAssetIntegrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cloudAssetIntegrationsAPIDeleteCloudAssetIntegration(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a cloud asset integration.
         * @summary Get a cloud asset integration.
         * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIGetCloudAssetIntegration(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CloudAssetIntegration> {
            return localVarFp.cloudAssetIntegrationsAPIGetCloudAssetIntegration(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the cleanup command for a cloud provider. This will clean up all resources for the specified cloud provider.
         * @summary Get the cleanup command for a cloud provider.
         * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommandRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommand(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommandRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCloudAssetIntegrationCleanupCommandResponse> {
            return localVarFp.cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommand(requestParameters.organizationId, requestParameters.provider, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the cleanup script for a cloud provider. This will clean up all resources for the specified cloud provider.
         * @summary Get the cleanup script for a cloud provider.
         * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScript(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScript(requestParameters.organizationId, requestParameters.provider, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the onboarding command for a cloud asset integration.
         * @summary Get the onboarding command for a cloud asset integration.
         * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCloudAssetIntegrationOnboardingCommandResponse> {
            return localVarFp.cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand(requestParameters.organizationId, requestParameters.provider, requestParameters.gcpConfigOrganizationIds, requestParameters.gcpConfigProjectId, requestParameters.gcpConfigProjectIds, requestParameters.azureConfigTenantId, requestParameters.azureConfigSubscriptionIds, requestParameters.awsConfigCurConfigS3BucketName, requestParameters.awsConfigCurConfigS3Region, requestParameters.awsConfigCurConfigS3AccountId, requestParameters.awsConfigForceAccountScope, requestParameters.awsConfigAccountIds, requestParameters.scope, requestParameters.integrationSettingsCommitmentsDefaultStatus, requestParameters.integrationSettingsCommitmentsAssignAutomatically, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the onboarding config for a cloud asset integration. Returns structured configuration  including provider-specific permissions and identifiers needed for programmatic onboarding (e.g. Terraform).
         * @summary Get the onboarding config for a cloud asset integration.
         * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCloudAssetIntegrationOnboardingConfigResponse> {
            return localVarFp.cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig(requestParameters.organizationId, requestParameters.provider, requestParameters.gcpConfigOrganizationIds, requestParameters.gcpConfigProjectId, requestParameters.gcpConfigProjectIds, requestParameters.azureConfigTenantId, requestParameters.azureConfigSubscriptionIds, requestParameters.awsConfigCurConfigS3BucketName, requestParameters.awsConfigCurConfigS3Region, requestParameters.awsConfigCurConfigS3AccountId, requestParameters.awsConfigForceAccountScope, requestParameters.awsConfigAccountIds, requestParameters.scope, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the onboarding script for a cloud asset integration.
         * @summary Get the onboarding script for a cloud asset integration.
         * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScript(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScript(requestParameters.organizationId, requestParameters.provider, requestParameters.trackingSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the sync report for a cloud asset integration.  The report is a singleton sub-resource of the integration and contains the  most recent sync run for each (provider_namespace_id, asset_type) pair,  exposing the same rows that feed the derived CloudAssetIntegration.state.
         * @summary Get the sync report for a cloud asset integration.
         * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReport(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<CloudAssetIntegrationSyncReport> {
            return localVarFp.cloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReport(requestParameters.organizationId, requestParameters.cloudAssetIntegrationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists cloud asset integrations.
         * @summary Lists cloud asset integrations.
         * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIListCloudAssetIntegrationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIListCloudAssetIntegrations(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIListCloudAssetIntegrationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListCloudAssetIntegrationsResponse> {
            return localVarFp.cloudAssetIntegrationsAPIListCloudAssetIntegrations(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing cloud asset integration.
         * @summary Update an existing cloud asset integration.
         * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIUpdateCloudAssetIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloudAssetIntegrationsAPIUpdateCloudAssetIntegration(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIUpdateCloudAssetIntegrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CloudAssetIntegration> {
            return localVarFp.cloudAssetIntegrationsAPIUpdateCloudAssetIntegration(requestParameters.organizationId, requestParameters.id, requestParameters.updateCloudAssetIntegrationInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cloudAssetIntegrationsAPICreateCloudAssetIntegration operation in CloudAssetIntegrationsAPIApi.
 * @export
 * @interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPICreateCloudAssetIntegrationRequest
 */
export interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPICreateCloudAssetIntegrationRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPICreateCloudAssetIntegration
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreateCloudAssetIntegrationInput}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPICreateCloudAssetIntegration
     */
    readonly createCloudAssetIntegrationInput: CreateCloudAssetIntegrationInput
}

/**
 * Request parameters for cloudAssetIntegrationsAPIDeleteCloudAssetIntegration operation in CloudAssetIntegrationsAPIApi.
 * @export
 * @interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIDeleteCloudAssetIntegrationRequest
 */
export interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIDeleteCloudAssetIntegrationRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIDeleteCloudAssetIntegration
     */
    readonly organizationId: string

    /**
     * The ID of the cloud asset integration.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIDeleteCloudAssetIntegration
     */
    readonly id: string
}

/**
 * Request parameters for cloudAssetIntegrationsAPIGetCloudAssetIntegration operation in CloudAssetIntegrationsAPIApi.
 * @export
 * @interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationRequest
 */
export interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegration
     */
    readonly organizationId: string

    /**
     * The ID of the cloud asset integration.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegration
     */
    readonly id: string
}

/**
 * Request parameters for cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommand operation in CloudAssetIntegrationsAPIApi.
 * @export
 * @interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommandRequest
 */
export interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommandRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommand
     */
    readonly organizationId: string

    /**
     * The cloud provider to clean up resources for.
     * @type {'CLOUD_UNSPECIFIED' | 'GCP' | 'AWS' | 'AZURE' | 'ORACLE' | 'NEBIUS'}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommand
     */
    readonly provider?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommandProviderEnum
}

/**
 * Request parameters for cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScript operation in CloudAssetIntegrationsAPIApi.
 * @export
 * @interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScriptRequest
 */
export interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScriptRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScript
     */
    readonly organizationId: string

    /**
     * The cloud provider to clean up resources for.
     * @type {'CLOUD_UNSPECIFIED' | 'GCP' | 'AWS' | 'AZURE' | 'ORACLE' | 'NEBIUS'}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScript
     */
    readonly provider?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScriptProviderEnum
}

/**
 * Request parameters for cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand operation in CloudAssetIntegrationsAPIApi.
 * @export
 * @interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandRequest
 */
export interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand
     */
    readonly organizationId: string

    /**
     * The cloud provider.
     * @type {'CLOUD_UNSPECIFIED' | 'GCP' | 'AWS' | 'AZURE' | 'ORACLE' | 'NEBIUS'}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand
     */
    readonly provider?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandProviderEnum

    /**
     * Optional GCP organization IDs. If provided, the onboarding script will attempt to create organization-level IAM bindings only for the specified organizations.
     * @type {Array<string>}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand
     */
    readonly gcpConfigOrganizationIds?: Array<string>

    /**
     * Optional GCP project ID. If provided, the onboarding script will create a service account in this project.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand
     */
    readonly gcpConfigProjectId?: string

    /**
     * Optional GCP project IDs. If provided, the onboarding script will create IAM bindings only in these projects.
     * @type {Array<string>}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand
     */
    readonly gcpConfigProjectIds?: Array<string>

    /**
     * Optional Azure tenant ID. If provided, the onboarding script will setup the integration for the specified tenant. Otherwise, it will programatically obtain the tenant ID from the Azure CLI.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand
     */
    readonly azureConfigTenantId?: string

    /**
     * Optional list of Azure subscription IDs to restrict the integration to. If provided, the onboarding script will only setup access for these subscriptions. Otherwise, it will setup access for all available subscriptions.
     * @type {Array<string>}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand
     */
    readonly azureConfigSubscriptionIds?: Array<string>

    /**
     * S3 bucket name containing a CUR export. If provided, the onboarding script will create an IAM policy to allow access to the specified bucket.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand
     */
    readonly awsConfigCurConfigS3BucketName?: string

    /**
     * Region of the S3 bucket containing the CUR export. Must be provided if s3_bucket_name is provided.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand
     */
    readonly awsConfigCurConfigS3Region?: string

    /**
     * Optional AWS account ID containing the CUR export for organization-scoped integrations. If not provided, defaults to management account ID.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand
     */
    readonly awsConfigCurConfigS3AccountId?: string

    /**
     * If true, the onboarding script will force account-scoped integration even if it\&#39;s ran by a management account.
     * @type {boolean}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand
     */
    readonly awsConfigForceAccountScope?: boolean

    /**
     * Optional list of AWS account IDs to restrict the integration to. For organization-scoped integrations, the onboarding script will only deploy roles to these accounts. The integration will only sync resources from these accounts.
     * @type {Array<string>}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand
     */
    readonly awsConfigAccountIds?: Array<string>

    /**
     * The scope of the cloud asset integration. If not provided, defaults to ALL.
     * @type {'CLOUD_ASSET_INTEGRATION_SCOPE_UNSPECIFIED' | 'ALL' | 'AWS_COMMITMENTS' | 'AZURE_COMMITMENTS' | 'ALL_MINIMAL_PERMISSIONS' | 'AWS_AI_SERVICES' | 'GCP_COMMITMENTS' | 'DBO'}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand
     */
    readonly scope?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandScopeEnum

    /**
     * The default status of the commitment to be assigned to newly imported ones.
     * @type {'COMMITMENT_STATUS_UNSPECIFIED' | 'ACTIVE' | 'INACTIVE'}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand
     */
    readonly integrationSettingsCommitmentsDefaultStatus?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandIntegrationSettingsCommitmentsDefaultStatusEnum

    /**
     * If true, the commitment will be automatically assigned to clusters.
     * @type {boolean}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand
     */
    readonly integrationSettingsCommitmentsAssignAutomatically?: boolean
}

/**
 * Request parameters for cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig operation in CloudAssetIntegrationsAPIApi.
 * @export
 * @interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigRequest
 */
export interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig
     */
    readonly organizationId: string

    /**
     * The cloud provider.
     * @type {'CLOUD_UNSPECIFIED' | 'GCP' | 'AWS' | 'AZURE' | 'ORACLE' | 'NEBIUS'}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig
     */
    readonly provider?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigProviderEnum

    /**
     * Optional GCP organization IDs. If provided, the onboarding script will attempt to create organization-level IAM bindings only for the specified organizations.
     * @type {Array<string>}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig
     */
    readonly gcpConfigOrganizationIds?: Array<string>

    /**
     * Optional GCP project ID. If provided, the onboarding script will create a service account in this project.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig
     */
    readonly gcpConfigProjectId?: string

    /**
     * Optional GCP project IDs. If provided, the onboarding script will create IAM bindings only in these projects.
     * @type {Array<string>}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig
     */
    readonly gcpConfigProjectIds?: Array<string>

    /**
     * Optional Azure tenant ID. If provided, the onboarding script will setup the integration for the specified tenant. Otherwise, it will programatically obtain the tenant ID from the Azure CLI.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig
     */
    readonly azureConfigTenantId?: string

    /**
     * Optional list of Azure subscription IDs to restrict the integration to. If provided, the onboarding script will only setup access for these subscriptions. Otherwise, it will setup access for all available subscriptions.
     * @type {Array<string>}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig
     */
    readonly azureConfigSubscriptionIds?: Array<string>

    /**
     * S3 bucket name containing a CUR export. If provided, the onboarding script will create an IAM policy to allow access to the specified bucket.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig
     */
    readonly awsConfigCurConfigS3BucketName?: string

    /**
     * Region of the S3 bucket containing the CUR export. Must be provided if s3_bucket_name is provided.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig
     */
    readonly awsConfigCurConfigS3Region?: string

    /**
     * Optional AWS account ID containing the CUR export for organization-scoped integrations. If not provided, defaults to management account ID.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig
     */
    readonly awsConfigCurConfigS3AccountId?: string

    /**
     * If true, the onboarding script will force account-scoped integration even if it\&#39;s ran by a management account.
     * @type {boolean}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig
     */
    readonly awsConfigForceAccountScope?: boolean

    /**
     * Optional list of AWS account IDs to restrict the integration to. For organization-scoped integrations, the onboarding script will only deploy roles to these accounts. The integration will only sync resources from these accounts.
     * @type {Array<string>}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig
     */
    readonly awsConfigAccountIds?: Array<string>

    /**
     * The scope of the cloud asset integration. If not provided, defaults to ALL.
     * @type {'CLOUD_ASSET_INTEGRATION_SCOPE_UNSPECIFIED' | 'ALL' | 'AWS_COMMITMENTS' | 'AZURE_COMMITMENTS' | 'ALL_MINIMAL_PERMISSIONS' | 'AWS_AI_SERVICES' | 'GCP_COMMITMENTS' | 'DBO'}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig
     */
    readonly scope?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigScopeEnum
}

/**
 * Request parameters for cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScript operation in CloudAssetIntegrationsAPIApi.
 * @export
 * @interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScriptRequest
 */
export interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScriptRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScript
     */
    readonly organizationId: string

    /**
     * The cloud provider.
     * @type {'CLOUD_UNSPECIFIED' | 'GCP' | 'AWS' | 'AZURE' | 'ORACLE' | 'NEBIUS'}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScript
     */
    readonly provider?: CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScriptProviderEnum

    /**
     * Tracking session ID that should be passed if client wants to  associate GetCloudAssetIntegrationOnboardingScriptRequest with tracking session
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScript
     */
    readonly trackingSessionId?: string
}

/**
 * Request parameters for cloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReport operation in CloudAssetIntegrationsAPIApi.
 * @export
 * @interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReportRequest
 */
export interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReportRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReport
     */
    readonly organizationId: string

    /**
     * The ID of the cloud asset integration.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReport
     */
    readonly cloudAssetIntegrationId: string
}

/**
 * Request parameters for cloudAssetIntegrationsAPIListCloudAssetIntegrations operation in CloudAssetIntegrationsAPIApi.
 * @export
 * @interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIListCloudAssetIntegrationsRequest
 */
export interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIListCloudAssetIntegrationsRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIListCloudAssetIntegrations
     */
    readonly organizationId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIListCloudAssetIntegrations
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIListCloudAssetIntegrations
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for cloudAssetIntegrationsAPIUpdateCloudAssetIntegration operation in CloudAssetIntegrationsAPIApi.
 * @export
 * @interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIUpdateCloudAssetIntegrationRequest
 */
export interface CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIUpdateCloudAssetIntegrationRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIUpdateCloudAssetIntegration
     */
    readonly organizationId: string

    /**
     * The ID of the cloud asset integration.
     * @type {string}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIUpdateCloudAssetIntegration
     */
    readonly id: string

    /**
     * 
     * @type {UpdateCloudAssetIntegrationInput}
     * @memberof CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIUpdateCloudAssetIntegration
     */
    readonly updateCloudAssetIntegrationInput: UpdateCloudAssetIntegrationInput
}

/**
 * CloudAssetIntegrationsAPIApi - object-oriented interface
 * @export
 * @class CloudAssetIntegrationsAPIApi
 * @extends {BaseAPI}
 */
export class CloudAssetIntegrationsAPIApi extends BaseAPI {
    /**
     * Creates a new cloud asset integration.
     * @summary Create a new cloud asset integration.
     * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPICreateCloudAssetIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudAssetIntegrationsAPIApi
     */
    public cloudAssetIntegrationsAPICreateCloudAssetIntegration(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPICreateCloudAssetIntegrationRequest, options?: RawAxiosRequestConfig) {
        return CloudAssetIntegrationsAPIApiFp(this.configuration).cloudAssetIntegrationsAPICreateCloudAssetIntegration(requestParameters.organizationId, requestParameters.createCloudAssetIntegrationInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a cloud asset integration.
     * @summary Delete a cloud asset integration.
     * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIDeleteCloudAssetIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudAssetIntegrationsAPIApi
     */
    public cloudAssetIntegrationsAPIDeleteCloudAssetIntegration(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIDeleteCloudAssetIntegrationRequest, options?: RawAxiosRequestConfig) {
        return CloudAssetIntegrationsAPIApiFp(this.configuration).cloudAssetIntegrationsAPIDeleteCloudAssetIntegration(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a cloud asset integration.
     * @summary Get a cloud asset integration.
     * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudAssetIntegrationsAPIApi
     */
    public cloudAssetIntegrationsAPIGetCloudAssetIntegration(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationRequest, options?: RawAxiosRequestConfig) {
        return CloudAssetIntegrationsAPIApiFp(this.configuration).cloudAssetIntegrationsAPIGetCloudAssetIntegration(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the cleanup command for a cloud provider. This will clean up all resources for the specified cloud provider.
     * @summary Get the cleanup command for a cloud provider.
     * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudAssetIntegrationsAPIApi
     */
    public cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommand(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommandRequest, options?: RawAxiosRequestConfig) {
        return CloudAssetIntegrationsAPIApiFp(this.configuration).cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommand(requestParameters.organizationId, requestParameters.provider, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the cleanup script for a cloud provider. This will clean up all resources for the specified cloud provider.
     * @summary Get the cleanup script for a cloud provider.
     * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudAssetIntegrationsAPIApi
     */
    public cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScript(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScriptRequest, options?: RawAxiosRequestConfig) {
        return CloudAssetIntegrationsAPIApiFp(this.configuration).cloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScript(requestParameters.organizationId, requestParameters.provider, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the onboarding command for a cloud asset integration.
     * @summary Get the onboarding command for a cloud asset integration.
     * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudAssetIntegrationsAPIApi
     */
    public cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandRequest, options?: RawAxiosRequestConfig) {
        return CloudAssetIntegrationsAPIApiFp(this.configuration).cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommand(requestParameters.organizationId, requestParameters.provider, requestParameters.gcpConfigOrganizationIds, requestParameters.gcpConfigProjectId, requestParameters.gcpConfigProjectIds, requestParameters.azureConfigTenantId, requestParameters.azureConfigSubscriptionIds, requestParameters.awsConfigCurConfigS3BucketName, requestParameters.awsConfigCurConfigS3Region, requestParameters.awsConfigCurConfigS3AccountId, requestParameters.awsConfigForceAccountScope, requestParameters.awsConfigAccountIds, requestParameters.scope, requestParameters.integrationSettingsCommitmentsDefaultStatus, requestParameters.integrationSettingsCommitmentsAssignAutomatically, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the onboarding config for a cloud asset integration. Returns structured configuration  including provider-specific permissions and identifiers needed for programmatic onboarding (e.g. Terraform).
     * @summary Get the onboarding config for a cloud asset integration.
     * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudAssetIntegrationsAPIApi
     */
    public cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigRequest, options?: RawAxiosRequestConfig) {
        return CloudAssetIntegrationsAPIApiFp(this.configuration).cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfig(requestParameters.organizationId, requestParameters.provider, requestParameters.gcpConfigOrganizationIds, requestParameters.gcpConfigProjectId, requestParameters.gcpConfigProjectIds, requestParameters.azureConfigTenantId, requestParameters.azureConfigSubscriptionIds, requestParameters.awsConfigCurConfigS3BucketName, requestParameters.awsConfigCurConfigS3Region, requestParameters.awsConfigCurConfigS3AccountId, requestParameters.awsConfigForceAccountScope, requestParameters.awsConfigAccountIds, requestParameters.scope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the onboarding script for a cloud asset integration.
     * @summary Get the onboarding script for a cloud asset integration.
     * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudAssetIntegrationsAPIApi
     */
    public cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScript(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScriptRequest, options?: RawAxiosRequestConfig) {
        return CloudAssetIntegrationsAPIApiFp(this.configuration).cloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScript(requestParameters.organizationId, requestParameters.provider, requestParameters.trackingSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the sync report for a cloud asset integration.  The report is a singleton sub-resource of the integration and contains the  most recent sync run for each (provider_namespace_id, asset_type) pair,  exposing the same rows that feed the derived CloudAssetIntegration.state.
     * @summary Get the sync report for a cloud asset integration.
     * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudAssetIntegrationsAPIApi
     */
    public cloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReport(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReportRequest, options?: RawAxiosRequestConfig) {
        return CloudAssetIntegrationsAPIApiFp(this.configuration).cloudAssetIntegrationsAPIGetCloudAssetIntegrationSyncReport(requestParameters.organizationId, requestParameters.cloudAssetIntegrationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists cloud asset integrations.
     * @summary Lists cloud asset integrations.
     * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIListCloudAssetIntegrationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudAssetIntegrationsAPIApi
     */
    public cloudAssetIntegrationsAPIListCloudAssetIntegrations(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIListCloudAssetIntegrationsRequest, options?: RawAxiosRequestConfig) {
        return CloudAssetIntegrationsAPIApiFp(this.configuration).cloudAssetIntegrationsAPIListCloudAssetIntegrations(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing cloud asset integration.
     * @summary Update an existing cloud asset integration.
     * @param {CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIUpdateCloudAssetIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudAssetIntegrationsAPIApi
     */
    public cloudAssetIntegrationsAPIUpdateCloudAssetIntegration(requestParameters: CloudAssetIntegrationsAPIApiCloudAssetIntegrationsAPIUpdateCloudAssetIntegrationRequest, options?: RawAxiosRequestConfig) {
        return CloudAssetIntegrationsAPIApiFp(this.configuration).cloudAssetIntegrationsAPIUpdateCloudAssetIntegration(requestParameters.organizationId, requestParameters.id, requestParameters.updateCloudAssetIntegrationInput, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommandProviderEnum = {
    CLOUD_UNSPECIFIED: 'CLOUD_UNSPECIFIED',
    GCP: 'GCP',
    AWS: 'AWS',
    AZURE: 'AZURE',
    ORACLE: 'ORACLE',
    NEBIUS: 'NEBIUS'
} as const;
export type CloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommandProviderEnum = typeof CloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommandProviderEnum[keyof typeof CloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupCommandProviderEnum];
/**
 * @export
 */
export const CloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScriptProviderEnum = {
    CLOUD_UNSPECIFIED: 'CLOUD_UNSPECIFIED',
    GCP: 'GCP',
    AWS: 'AWS',
    AZURE: 'AZURE',
    ORACLE: 'ORACLE',
    NEBIUS: 'NEBIUS'
} as const;
export type CloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScriptProviderEnum = typeof CloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScriptProviderEnum[keyof typeof CloudAssetIntegrationsAPIGetCloudAssetIntegrationCleanupScriptProviderEnum];
/**
 * @export
 */
export const CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandProviderEnum = {
    CLOUD_UNSPECIFIED: 'CLOUD_UNSPECIFIED',
    GCP: 'GCP',
    AWS: 'AWS',
    AZURE: 'AZURE',
    ORACLE: 'ORACLE',
    NEBIUS: 'NEBIUS'
} as const;
export type CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandProviderEnum = typeof CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandProviderEnum[keyof typeof CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandProviderEnum];
/**
 * @export
 */
export const CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandScopeEnum = {
    CLOUD_ASSET_INTEGRATION_SCOPE_UNSPECIFIED: 'CLOUD_ASSET_INTEGRATION_SCOPE_UNSPECIFIED',
    ALL: 'ALL',
    AWS_COMMITMENTS: 'AWS_COMMITMENTS',
    AZURE_COMMITMENTS: 'AZURE_COMMITMENTS',
    ALL_MINIMAL_PERMISSIONS: 'ALL_MINIMAL_PERMISSIONS',
    AWS_AI_SERVICES: 'AWS_AI_SERVICES',
    GCP_COMMITMENTS: 'GCP_COMMITMENTS',
    DBO: 'DBO'
} as const;
export type CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandScopeEnum = typeof CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandScopeEnum[keyof typeof CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandScopeEnum];
/**
 * @export
 */
export const CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandIntegrationSettingsCommitmentsDefaultStatusEnum = {
    COMMITMENT_STATUS_UNSPECIFIED: 'COMMITMENT_STATUS_UNSPECIFIED',
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE'
} as const;
export type CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandIntegrationSettingsCommitmentsDefaultStatusEnum = typeof CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandIntegrationSettingsCommitmentsDefaultStatusEnum[keyof typeof CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingCommandIntegrationSettingsCommitmentsDefaultStatusEnum];
/**
 * @export
 */
export const CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigProviderEnum = {
    CLOUD_UNSPECIFIED: 'CLOUD_UNSPECIFIED',
    GCP: 'GCP',
    AWS: 'AWS',
    AZURE: 'AZURE',
    ORACLE: 'ORACLE',
    NEBIUS: 'NEBIUS'
} as const;
export type CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigProviderEnum = typeof CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigProviderEnum[keyof typeof CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigProviderEnum];
/**
 * @export
 */
export const CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigScopeEnum = {
    CLOUD_ASSET_INTEGRATION_SCOPE_UNSPECIFIED: 'CLOUD_ASSET_INTEGRATION_SCOPE_UNSPECIFIED',
    ALL: 'ALL',
    AWS_COMMITMENTS: 'AWS_COMMITMENTS',
    AZURE_COMMITMENTS: 'AZURE_COMMITMENTS',
    ALL_MINIMAL_PERMISSIONS: 'ALL_MINIMAL_PERMISSIONS',
    AWS_AI_SERVICES: 'AWS_AI_SERVICES',
    GCP_COMMITMENTS: 'GCP_COMMITMENTS',
    DBO: 'DBO'
} as const;
export type CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigScopeEnum = typeof CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigScopeEnum[keyof typeof CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingConfigScopeEnum];
/**
 * @export
 */
export const CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScriptProviderEnum = {
    CLOUD_UNSPECIFIED: 'CLOUD_UNSPECIFIED',
    GCP: 'GCP',
    AWS: 'AWS',
    AZURE: 'AZURE',
    ORACLE: 'ORACLE',
    NEBIUS: 'NEBIUS'
} as const;
export type CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScriptProviderEnum = typeof CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScriptProviderEnum[keyof typeof CloudAssetIntegrationsAPIGetCloudAssetIntegrationOnboardingScriptProviderEnum];
